import { Controller } from 'react-hook-form';
import { CheckBox } from 'ui-components';

type ControlledCheckProps = {
  name: string;
  label: string;
};

export function ControlledCheckBox({ name, label }: ControlledCheckProps): JSX.Element {
  return (
    <Controller
      name={name}
      render={({ field: { value, onChange } }) => (
        <CheckBox checked={value} onChange={onChange} name={name} label={label} />
      )}
    />
  );
}
